module.exports = __webpack_public_path__ + "static/media/morphos_front.30cd94e4.png";